import { Navigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import React from 'react';

const PrivateRoute = ({ children, allowedRoles }) => {
  const accessToken = localStorage.getItem('access_token');
  const userRole = localStorage.getItem('user_role');
  const userTokensRelatedString = localStorage.getItem('user_tokens_related');
  const isAccount = localStorage.getItem('is_account') === 'true';
  const isAggregator = localStorage.getItem('is_aggregator') === 'true';
  const provider = localStorage.getItem('provider') || '';
  
  let userTokensRelated = [];
  try {
    userTokensRelated = userTokensRelatedString ? JSON.parse(userTokensRelatedString) : [];
  } catch (e) {
    console.error("Error parsing user_tokens_related from localStorage:", e);
  }

  const location = useLocation();
  const currentPath = location.pathname;

  // 1. Validar login
  if (!accessToken) {
    return <Navigate to="/Inicio" replace />;
  }

  // 2. Definición de "Cuentita" (Ni isAccount ni isAggregator)
  const isCuentita = !isAccount && !isAggregator;

  // 3. Validación General de Roles
  // Si la ruta define roles permitidos, y el rol del usuario no está ahí, bloquear.
  if (allowedRoles && (!userRole || !allowedRoles.includes(userRole))) {
    // Para evitar loops infinitos, si el usuario está logueado mandarlo a Transacciones
    toast.error(`Acceso denegado: Se requiere rol ${allowedRoles.join(' o ')}.`);
    return <Navigate to="/Master/Transacciones" replace />;
  }

  // 4. Reglas de Negocio Específicas
  const isDepositos = currentPath === '/Master/Depositos';
  const isRecurrentes = currentPath === '/Master/Recurrentes';
  const isSmartlinksRoute = currentPath.startsWith('/Master/Smartlinks') || currentPath === '/Master/LinksView';
  const isInicio = currentPath === '/Master/Inicio';

  // Smartlinks y Recurrentes: Exclusivo para "Cuentitas"
  if ((isSmartlinksRoute || isRecurrentes) && !isCuentita) {
    toast.error('Esta funcionalidad no está disponible para tu tipo de cuenta.');
    return <Navigate to="/Master/Transacciones" replace />;
  }

  // Recurrentes: Exclusivo para proveedor "Blumon"
  if (isRecurrentes && provider !== 'Blumon') {
    toast.error('Esta funcionalidad no está disponible para tu proveedor.');
    return <Navigate to="/Master/Transacciones" replace />;
  }

  // Depositos: Exclusivo para "Cuentitas"
  if (isDepositos && !isCuentita) {
    toast.error('Los depósitos no están disponibles para tu tipo de cuenta.');
    return <Navigate to="/Master/Transacciones" replace />;
  }

  // Múltiples Tokens: Si la lista está vacía, solo puede acceder a Transacciones
  if (userTokensRelated.length === 0) {
    if (isInicio) { // Bloqueamos el paso a Inicio / Depositos
      toast.error('No tienes sucursales asignadas para ver esta sección.');
      return <Navigate to="/Master/Transacciones" replace />;
    }
  }

  // Si pasó todas las validaciones síncronas, renderizar el componente.
  return children;
};

export default PrivateRoute;
